import Heading from "../heading/heading";
import styles from "./section-head.module.less";

type TSectionHeadProps = {
  heading: string;
  text?: string;
  index?: number;
};

const SectionHead = ({ heading, text, index }: TSectionHeadProps) => {
  return (
    <div className={styles.wrapper}>
      <div className={[styles.innerWrapper].join(" ")}>
        <div className={`heading-max-width ${styles.textWrapper}`}>
          {heading && (
            <Heading index={index} semanticType={"h2"} visualType={"h2"} className={styles.heading}>
              {heading}
            </Heading>
          )}
          {text && <p className={[styles.text, "body-base text-max-width"].join(" ")}>{text}</p>}
        </div>
      </div>
    </div>
  );
};

export default SectionHead;
